module.exports = __webpack_public_path__ + "img/icon-pfeil-slider_links_weiss.ac32e58d.svg";